import axios from "axios";
import Cookie from 'js-cookie';
import {PROTECTED_API_URL} from "./settings";
import * as T from '../utils/types'
import { Creation } from "../utils-creation/types";
import { now } from "lodash";

export const protected_axios = axios.create({
    baseURL: PROTECTED_API_URL,
    headers: {
        'X-CSRFToken': Cookie.get('csrftoken')
    }
});

export const getUser = async (): Promise<T.UserGETResponse> => {
    const url = 'user/';
    const {data} = await protected_axios.get(url);
    return data;
};

export const getGeneralInfo = async (): Promise<T.GeneralInfoGETResponse> => {
    const url = 'general_info/'
    // console.log('fetching general info from: ', url);
    const {data} = await protected_axios.get(url);

    return data;
};

export const patchGeneralInfo = async (body: T.GeneralInfoPATCHRequest): Promise<T.GeneralInfoGETResponse> => {
    const url = 'general_info/'
    // console.log('putting general info to: ', url);
    // console.log('data: ', body);
    const {data} = await protected_axios.patch(url, body);
    return data;
};

export const getSDGvec = async (): Promise<T.SDGvecGETResponse> => {
    const url = 'general_info/SDG/'
    // console.log('fetching SDGvec from: ', url);
    const {data} = await protected_axios.get(url);
    return data;
};

export const patchSDGvec = async (index:number, status:boolean): Promise<T.SDGvecGETResponse> => {
    const url = 'general_info/SDG/'
    // console.log('patch SDGvec');
    const {data} = await protected_axios.patch(
        url, { index, status }
    );
    return data;
};

export const postCreation = async (payload: any): Promise<any> => {
    const url = 'creations/';
    const { data } = await protected_axios.post(url, payload);
    return data;
}

export const getCreation = async (id: number): Promise<any> => {
    const url = `creations/${id}/`;
    const { data } = await protected_axios.get(url);
    return data;
}

export const putCreation = async (payload: Creation): Promise<any> => {
    const url = `creations/put/${payload.id}/`;
    const { data } = await protected_axios.put(url, payload);
    return data;
}

export const deleteCreation = async (id: number): Promise<any> => {
    const url = `creations/${id}/`;
    const { data } = await protected_axios.delete(url);
    return data;
}